"use strict";
var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
var __metadata = (this && this.__metadata) || function (k, v) {
    if (typeof Reflect === "object" && typeof Reflect.metadata === "function") return Reflect.metadata(k, v);
};
var core_1 = require("@angular/core");
var validators_1 = require("./../../validators");
var moment = require("moment");
var AcknowledgementService = AcknowledgementService_1 = (function () {
    function AcknowledgementService() {
    }
    // uses the identifier to find all acks that pertain to a specific flight
    AcknowledgementService.getAcknowledgementsForFlight = function (flight, acknowledgements) {
        var acks = [];
        if (acknowledgements && flight) {
            acknowledgements.forEach(function (ack) {
                if (ack.typeIdentifier) {
                    // example: 2019-10-02|ORD|UA|5615
                    var identifiers = ack.typeIdentifier.split('|');
                    if (identifiers.length === 4) {
                        var departureDateIndex = 0;
                        var departureAirportCodeIndex = 1;
                        var airlineCodeIndex = 2;
                        var flightNumberIndex = 3;
                        var matches = true;
                        // if no data matches, skip the
                        var airlineCode = null;
                        if (flight.airline) {
                            airlineCode = flight.airline.providerCode;
                        }
                        if (identifiers[airlineCodeIndex] !== airlineCode ||
                            identifiers[flightNumberIndex] !== flight.flightNumber ||
                            identifiers[departureAirportCodeIndex] !== flight.departureAirport) {
                            matches = false;
                        }
                        if (matches) {
                            var ackDate = moment(identifiers[departureDateIndex], validators_1.Constants.DATE_PARSE_FORMAT);
                            var flightDate = moment(flight.flightDate, validators_1.Constants.DATE_PARSE_FORMAT);
                            if (ackDate.isSame(flightDate)) {
                                acks.push(ack);
                            }
                        }
                    }
                    else {
                        console.warn("Invalid Acknowledgement Format: " + ack.typeIdentifier);
                    }
                }
            });
        }
        return acks;
    };
    AcknowledgementService.setAcknowledgementsOnCoverages = function (coverages, acknowledgements) {
        if (coverages) {
            coverages.forEach(function (c) {
                c.acknowledgements = AcknowledgementService_1.getAcknowledgementsForCoverage(c.ratingId, acknowledgements);
            });
        }
    };
    AcknowledgementService.getAcknowledgementsForCoverage = function (ratingId, acknowledgements) {
        var acks = [];
        if (acknowledgements && ratingId) {
            acknowledgements.forEach(function (ack) {
                if (ack.coverages && ack.coverages.some(function (c) { return c === ratingId; })) {
                    acks.push(ack);
                }
            });
        }
        return acks;
    };
    return AcknowledgementService;
}());
AcknowledgementService = AcknowledgementService_1 = __decorate([
    core_1.Injectable(),
    __metadata("design:paramtypes", [])
], AcknowledgementService);
exports.AcknowledgementService = AcknowledgementService;
var AcknowledgementService_1;



// WEBPACK FOOTER //
// ./~/@bhtp-client-web/component/src/misc/acknowledgements/acknowledgement.service.js